import { Grid, GridItem } from '@chakra-ui/layout';
import CallDespositions from './items/CallDespositions';
import DailyActivity from './items/DailyActivity';
import Recommendation from './items/Recommendation';
import UserInfo from './items/UserInfo';
import DetailedStatistics from './items/DetailedStatistics';

const templateAreas = `
    "UserInfo UserInfo"
    "DailyActivity CallDespositions"
    "DailyActivity Recommendation"
`;

const ActivityTracker = () => (
    <div>
        <Grid
            templateAreas={templateAreas}
            gridTemplateRows={'auto auto auto'}
            gridTemplateColumns={'1fr 390px'}
            gap={'8px'}
            mb="8px"
        >
            <GridItem area="UserInfo">
                <UserInfo />
            </GridItem>
            {/* <GridItem area="DailyActivity">
                <DailyActivity />
            </GridItem>
            <GridItem area="CallDespositions">
                <CallDespositions />
            </GridItem>
            <GridItem area="Recommendation">
                <Recommendation />
            </GridItem> */}
        </Grid>
        <DetailedStatistics />
    </div>
);

export default ActivityTracker;
